import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';

import styles from './HomeShowcaseSection.module.css';

interface HomeShowcaseSectionProps {
    className?: string;
    children?: ReactNode;
}

export const HomeShowcaseSection: FC<HomeShowcaseSectionProps> = ({ className, children }) => (
    <div className={classnames(styles.root, className)}>{children}</div>
);
